import React from 'react';
import { List, ListProps } from 'antd';

interface ListComponentProps<T> extends Omit<ListProps<T>, 'dataSource' | 'renderItem'> {
    data?: T[]; 
    renderItem?: (item: T, index: number) => React.ReactNode; 
}
const ListComponent = <T extends { id: string | number }>(
    props: ListComponentProps<T>
) => {
    const { data, renderItem, ...restProps } = props;
    
    const defaultRenderItem = (item: T, index: number) => {
    
        const handleClick = (item:T) => {
            console.log(`You clicked on: ${JSON.stringify(item)}`);
            // Do something else here, e.g., open a modal, navigate, update state, etc.
            // alert(`You clicked on: ${item}`); // For a visible example
            console.log(`${JSON.stringify(data)}`);
        };

        const displayText = (item as any).name || (item as any).title || `Item ${item.id}`;
        
        return (
            <List.Item
                key={item.id} // Ensures unique key based on the constraint
                onClick={() => handleClick(item)}
            >
                {displayText}
            </List.Item>
            );

    };
    return (
        <List<T> 
            dataSource={data} 
            renderItem={renderItem || defaultRenderItem}
            {...restProps}
            // renderItem={(item) => item && <List.Item onClick={() => handleClick(item)}>{item}</List.Item>} 
        />
    );
};

export default ListComponent;
